import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import LoginPage from '@/pages/login/page';
import LoadsPage from '@/pages/loads/page';
import LoadDetailPage from '@/pages/loads/detail';
import AppLayout from '@/components/feature/AppLayout';

const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'loads', element: <LoadsPage /> },
      { path: 'loads/:id', element: <LoadDetailPage /> },
    ],
  },
];

export default routes;